import { React, classNames, withStyles, StyledProps } from '@api'
import { Menu } from '@material-ui/icons'

import { AppBarIconButton, AppBarIconButtonProps } from './'

const styles = (theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-start'
  }
})

interface MyProps extends StyledProps, AppBarIconButtonProps {
  icon?: React.ReactNode
}

export class GlobalMenuComponent extends React.Component<MyProps> {
  static defaultProps = {
    icon: <Menu/>
    }

  render() {
    const {props: {classes, icon, ...otherProps}} = this;
    return (
      <div className={classes.root}>
        <AppBarIconButton icon={icon} {...otherProps} />
      </div>
    )
  }
}

@(withStyles as any)(styles)
export class GlobalMenu extends GlobalMenuComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/GlobalMenu.tsx